import { axios } from '@/utils/request'
import ipConfig from '../../config/ip.config'
import moment from 'moment'
export const api = {
  getroutelist: ipConfig.api_shell + '/tmswebapi/api/shellapi/statistics/getroutelist', // 线路获取
  getbasicdata: ipConfig.api_shell + '/tmswebapi/api/shellapi/statistics/getbasicdata',
  getmileagedata: ipConfig.api_shell + '/tmswebapi/api/shellapi/statistics/getmileagedata', // 里程统计
  getdispatchdata: ipConfig.api_shell + '/tmswebapi/api/shellapi/statistics/getdispatchdata', // 车次统计
  getcycledata: ipConfig.api_shell + '/tmswebapi/api/shellapi/statistics/getcycledata', // 月度付款结算交付折线
  getorderlist: ipConfig.api_shell + '/tmswebapi/api/shellapi/order/getorderlist', // 订单列表
  subscriptionorder: ipConfig.api_shell + '/tmswebapi/api/shellapi/order/subscriptionorder', // 关注订单操作
  getordertaskmilestonelist: ipConfig.api_shell + '/tmswebapi/api/shellapi/order/getordertaskmilestonelist', // 运单轨迹
  getinvoicelist: ipConfig.api_shell + '/tmswebapi/api/shellapi/invoice/getinvoicelist', // 账单列表
  getreceiptlist: ipConfig.api_shell + '/tmswebapi/api/shellapi/order/getreceiptlist', // 获取回单
  exportorderlist: ipConfig.api_shell + '/tmswebapi/ShellExport/ExportOrderListInfo', // 订单导出
  showpanel: ipConfig.api_shell + '/tmswebapi/api/shellapi/statistics/showpanel',
  GetSubscriptionList: ipConfig.api_shell + '/OfficialSite.WebApi/api/Official/GetSubscriptionList', // 获取历史订阅记录
  GetTopicList: ipConfig.api_shell + '/OfficialSite.WebApi/api/Official/GetTopicList', // 获取 指定板块的订阅主题列表
  UpdateSubscriptionStatus: ipConfig.api_shell + '/OfficialSite.WebApi/api/Official/UpdateSubscriptionStatus', // 更新订阅状态
  SaveUserSubscription: ipConfig.api_shell + '/OfficialSite.WebApi/api/Official/SaveUserSubscription', // 用户订阅
  UserFeedback: ipConfig.api_shell + '/OfficialSite.WebApi/api/Official/UserFeedback', // 用户反馈
  CheckCancelSubscriptionUrl: ipConfig.api_shell + '/OfficialSite.WebApi/api/Official/CheckCancelSubscriptionUrl', // 校验能否退订
}
export function getroutelist (data) {
  return axios({
    url: api.getroutelist,
    method: 'post',
    data
  })
}
export function getbasicdata (data) {
  return axios({
    url: api.getbasicdata,
    method: 'post',
    data
  })
}
export function getmileagedata (data) {
  return axios({
    url: api.getmileagedata,
    method: 'post',
    data
  })
}
export function getdispatchdata (data) {
  return axios({
    url: api.getdispatchdata,
    method: 'post',
    data
  })
}
export function getcycledata (data) {
  return axios({
    url: api.getcycledata,
    method: 'post',
    data
  })
}
export function getorderlist (data) {
  return axios({
    url: api.getorderlist,
    method: 'post',
    data
  })
}
export function getordertaskmilestonelist (data) {
  return axios({
    url: api.getordertaskmilestonelist,
    method: 'post',
    data,
    noToken: true
  })
}
export function getinvoicelist (data) {
  return axios({
    url: api.getinvoicelist,
    method: 'post',
    data
  })
}
export function getreceiptlist (data) {
  return axios({
    url: api.getreceiptlist,
    method: 'post',
    data,
    noToken: true
  })
}
export function exportorderlist (data) {
  const date = moment().format('YYYYMMDD')
  return axios({
    url: api.exportorderlist,
    method: 'post',
    data,
    fileName: 'Trucking_Export_' + date,
    responseType: 'blob'
  })
}
export function downloadFile (data) {
  return axios({
    url: data,
    method: 'get',
    responseType: 'blob',
    fileName: 'receiptOrder',
    noToken: true
  })
}
export function showpanel (data) {
  return axios({
    url: api.showpanel,
    method: 'post',
    data
  })
}
export function GetSubscriptionList (data) {
  return axios({
    url: api.GetSubscriptionList,
    method: 'post',
    data
  })
}
export function GetTopicList (data) {
  return axios({
    url: api.GetTopicList,
    method: 'post',
    data
  })
}
export function UpdateSubscriptionStatus (data) {
  return axios({
    url: api.UpdateSubscriptionStatus,
    method: 'post',
    data
  })
}
export function SaveUserSubscription (data) {
  return axios({
    url: api.SaveUserSubscription,
    method: 'post',
    data
  })
}
export function UserFeedback (data) {
  return axios({
    url: api.UserFeedback,
    method: 'post',
    data
  })
}
export function CheckCancelSubscriptionUrl (data) {
  return axios({
    url: api.CheckCancelSubscriptionUrl,
    method: 'post',
    data
  })
}
export function subscriptionorder (data) {
  return axios({
    url: api.subscriptionorder,
    method: 'post',
    data
  })
}
